import { Link } from 'react-router-dom';
import { useState } from 'react';

function Layout({ children }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#fdfcf7] text-gray-800">
      <header className="p-6 flex justify-between items-center shadow-sm bg-white relative z-10">
        <h1 className="text-2xl font-bold text-[#1a1a1a]">Creamoff</h1>
        <nav className="flex space-x-6 items-center">
          <Link to="/" className="text-gray-600 hover:text-black transition">Home</Link>

          {/* 톡테일 앱 클릭 드롭다운 */}
          <div className="relative">
            <button
              onClick={toggleDropdown}
              className="text-gray-600 hover:text-black transition flex items-center focus:outline-none"
            >
              톡테일 앱
              <svg
                className="ml-1 w-4 h-4 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M5.25 7.5L10 12.25L14.75 7.5H5.25Z" />
              </svg>
            </button>

            {dropdownOpen && (
              <div className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-md shadow-lg z-20">
                <Link
                  to="/talktailApp"
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  onClick={closeDropdown}
                >
                 고객센터
                </Link>
                <Link
                  to="/talktailApp/privacy"
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  onClick={closeDropdown}
                >
                  개인정보 처리방침
                </Link>
                <Link
                  to="/talktailApp/deletion"
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  onClick={closeDropdown}
                >
                  회원 삭제 링크
                </Link>

              </div>
            )}
          </div>
        </nav>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="p-6 text-center text-sm text-gray-400">
        © 2025 Creamoff. All rights reserved.
      </footer>
    </div>
  );
}

export default Layout;
